export function globalOnError(e: unknown) {
    if (typeof reportError === "function") {
        reportError(e);
    } else {
        setTimeout(() => {
            throw e;
        });
    }
}
